import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AgentRequests} from "../../services/agent-requests.service";
import {AgentModel} from "../../angular/models/agent.model";
import {AgentValidationType} from "../../types/agentValidation.type";
import {AgentPairingType} from "../../types/agentPairing.type";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";

export class AgentAppFeaturesCtrl implements IController {

  agent: AgentModel;
  preferences: any;

  public preferencesOriginal: any;
  public agentValidationTypesMap: typeof AgentValidationType = AgentValidationType;
  public agentPairingTypesMap: typeof AgentPairingType = AgentPairingType;

  public validationOptions;
  public pairingOptions;
  public isSaveAvailable: boolean = false;

  /* @ngInject */
  constructor(private $log, private commonsAlertsService: CommonsAlertsService, private agentRequests: AgentRequests, private bringozLoaderService: BringozLoaderService) {

  }

  $onInit() {
    this.preferencesOriginal = angular.copy(this.preferences);

    this.validationOptions = this.preferences.pairingOptions === AgentPairingType.Barcode ?
      [AgentValidationType.None, AgentValidationType.Barcode, AgentValidationType.Click] :
      (this.preferences.pairingOptions === AgentPairingType.ProNumber ? [AgentValidationType.None, AgentValidationType.ProNumber, AgentValidationType.Click] : angular.copy(Object.values(AgentValidationType)));
    this.pairingOptions = !!this.preferences.forcePairing ? [AgentPairingType.ProNumber, AgentPairingType.Barcode] : angular.copy(Object.values(AgentPairingType));
    this._setPairingOptions();
  }

  onChangeValidateBy(form, validationOption, propertyName) {
    this._setPairingOptions();

    if (validationOption === AgentValidationType.Barcode) {
      if (!_.includes(this.pairingOptions, this.preferences.pairingOption)) {
        this.preferences.pairingOption = AgentPairingType.Barcode;
      }
    } else if (validationOption === AgentValidationType.ProNumber) {
      this.preferences.pairingOption = AgentPairingType.ProNumber;
    } else if (validationOption === AgentValidationType.None) {
      this.preferences.quickValidation = false;
      if (!_.includes(this.pairingOptions, this.preferences.pairingOption)) {
        this.preferences.pairingOption = AgentPairingType.None;
      }
    } else if (validationOption === AgentValidationType.Click) {
      if (!_.includes(this.pairingOptions, this.preferences.pairingOption)) {
        this.preferences.pairingOption = AgentPairingType.None;
      }
    }
    this.onActiveChange();
  }

  onActiveChange() {
    this.isSaveAvailable = !_.isEqual(this.preferences, this.preferencesOriginal);
  }

  onSave(form, propertyName) {

    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this.bringozLoaderService.on();
        this.agentRequests.setAgentPreferences(this.preferences, this.agent.id)
          .then((preferences) => {
            this.preferences = preferences;
            this.preferencesOriginal = angular.copy(preferences);
            this.isSaveAvailable = false;
            this.commonsAlertsService.preferencesByNameSuccess(propertyName);
          })
          .catch((error) => {
            this.commonsAlertsService.preferencesError();
            this.$log.error('Failed to update agent preferences, @agentAppFeatures@onActiveChangePreferences', error);
          })
          .finally(() => {
            this.bringozLoaderService.off();
          })
      } else {
        this.commonsAlertsService.formInvalidInfo();
      }
    }

  }

  onCancelChanges() {
    this.preferences = angular.copy(this.preferencesOriginal);
    this.isSaveAvailable = false;
  }

  onForcePairingChange(form, forcePairing) {
    if (!!forcePairing) {
      this.pairingOptions = [AgentPairingType.ProNumber, AgentPairingType.Barcode];
      if (!_.includes(this.pairingOptions, this.preferences.pairingOption)) {
        this.preferences.pairingOption = this.pairingOptions[0];
      }
    }
    this.onActiveChange();
  }

  onPairingOptionChange(form, pairingOption) {
    if (pairingOption === AgentPairingType.Barcode) {
      this.preferences.quickValidation = false;
      this.validationOptions = [AgentValidationType.None, AgentValidationType.Barcode, AgentValidationType.Click];
      if (!_.includes(this.validationOptions, this.preferences.validationOption)) {
        this.preferences.validationOption = AgentValidationType.Barcode;
      }
    } else if (pairingOption === AgentPairingType.None) {
      this.validationOptions = angular.copy(Object.values(AgentValidationType));
      this.preferences.forcePairing = false;
    } else if (pairingOption === AgentPairingType.ProNumber) {
      this.validationOptions = [AgentValidationType.None, AgentValidationType.ProNumber, AgentValidationType.Click];
      if (!_.includes(this.validationOptions, this.preferences.validationOption)) {
        this.preferences.validationOption = AgentValidationType.ProNumber;
      }
    }
    this.onActiveChange()
  }

  private _setPairingOptions() {
    if (this.preferences.validationOption === AgentValidationType.Barcode) {
      this.pairingOptions = [AgentPairingType.None, AgentPairingType.Barcode];
    } else if (this.preferences.validationOption === AgentValidationType.ProNumber) {
      this.pairingOptions = [AgentPairingType.ProNumber];
    } else if (this.preferences.validationOption === AgentValidationType.None) {
      this.pairingOptions = [AgentPairingType.None, AgentPairingType.ProNumber, AgentPairingType.Barcode];
    } else if (this.preferences.validationOption === AgentValidationType.Click) {
      this.pairingOptions = [AgentPairingType.None, AgentPairingType.ProNumber, AgentPairingType.Barcode];
    } else {
      this.pairingOptions = angular.copy(Object.values(AgentPairingType));
    }
    // if (this.preferences.validationOption === AgentValidationType.Barcode) {
    //   this.pairingOptions = [AgentPairingType.None, AgentPairingType.Barcode];
    //   if (!_.includes(this.pairingOptions, this.preferences.pairingOption)) {
    //     this.preferences.pairingOption = AgentValidationType.Barcode;
    //   }
    // } else if (this.preferences.validationOption === AgentValidationType.ProNumber) {
    //   this.pairingOptions = [AgentPairingType.ProNumber];
    //   if (!_.includes(this.pairingOptions, this.preferences.pairingOption)) {
    //     this.preferences.pairingOption = AgentValidationType.ProNumber;
    //   }
    // } else {
    //   this.pairingOptions = angular.copy(Object.values(AgentPairingType));
    // }
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentAppFeatures', {
    bindings: {
      agent: '<',
      preferences: '<'
    },
    template: require('./agent-app-features.html').default,
    controller: AgentAppFeaturesCtrl
  });

